"use client";
import React, { useEffect, useState } from "react";
import { RenderHtmlFileWrapper } from "../../components/RenderHtmlFile";

export default function termsofservice() {
  return (
    <RenderHtmlFileWrapper file_name="/assets/20240829_Gebruiksvoorwaarden_eMindBrowser.html" />
    // <>
    //   <Header noNavigation={true} />
    //   <div className="max-w-screen-xl mt-24 px-8 xl:px-16 mx-auto">
    //     <PdfReader
    //       file={"/assets/20230908_Gebruiksvoorwaarden_eMindBrowser.pdf"}
    //     />
    //   </div>
    //   <Footer />
    // </>
  );
}
